import React, {Component} from 'react';
import StarRating from '@homeaway/react-star-rating';
import './TripBoardNewModal.less';
import classnames from 'classnames';

class TripBoardNewModal extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {
            rating,
            headline,
            reviewCount = 0,
            thumbnailUrl
        } = this.props;

        const reviewsClass = classnames({
            'reviews-hidden': reviewCount === 0,
            'rating-review': reviewCount > 0
        });

        return (
            <div className="trip-board-new-modal">
                <div className="trip-board-new-modal__left-column">
                    <div className="trip-board-new-modal__left-column-content">
                        <div className="trip-board-new-modal__image-container">
                            <div className="trip-board-new-modal__listing-image" style={{backgroundImage: thumbnailUrl ? `url(${thumbnailUrl})` : 'none'}}/>
                        </div>
                        <div className="trip-board-new-modal__info-container">
                            <div className="headline">
                                {headline}
                            </div>
                            <div className={reviewsClass}>
                                <div className="rating-review__rating">
                                    <StarRating rating={rating} />
                                </div>
                                <span className="rating-review__review-count">{reviewCount}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="trip-board-new-modal__right-column">
                    <div className="scroll-container">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default TripBoardNewModal;
